import React from 'react';
import { Button, Spin } from 'antd';
import { useTranslate } from '@/translations';
import { useAuthenticatedMedia } from '../hooks/useAuthenticatedMedia';

interface ImageMessageProps {
  eventId: string;
  mxc: string;
  thumbnailMxc?: string;
  alt: string;
  onOpenImage(eventId: string): void;
}

const MediaLoading = () => {
  const { t } = useTranslate();
  return (
    <span role="status" className="command-centre-chat__media-state">
      <Spin size="small" />
      <span>{t('commsMediaLoading')}</span>
    </span>
  );
};

const MediaFailure = ({ retry }: { retry(): void }) => {
  const { t } = useTranslate();
  return (
    <span role="alert" className="command-centre-chat__media-state">
      <span>{t('commsMediaUnavailable')}</span>
      <Button
        type="link"
        size="small"
        onClick={retry}
        aria-label={t('commsRetryMedia')}
      >
        {t('commsRetryMedia')}
      </Button>
    </span>
  );
};

export const ImageMessage = ({
  eventId,
  mxc,
  thumbnailMxc,
  alt,
  onOpenImage,
}: ImageMessageProps) => {
  const { t } = useTranslate();
  const inline = useAuthenticatedMedia(thumbnailMxc ?? mxc);

  if (inline.loading) return <MediaLoading />;
  if (inline.failed || !inline.url)
    return <MediaFailure retry={inline.retry} />;

  return (
    <button
      type="button"
      className="command-centre-chat__image-button"
      onClick={() => onOpenImage(eventId)}
      aria-label={t('commsOpenImagePreview')}
    >
      <img src={inline.url} alt={alt} className="comms-image" />
    </button>
  );
};
